import React from 'react';
import PropTypes from 'prop-types';

import { formatDateTime } from 'helpers/formatters/date_time_formats';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';

import UserIcon from 'components/user_icon';

export function Row({ event, stagesConfig }) {
  const { previousStage, stage, startTime, whodunnit } = event;

  let text;
  if (previousStage) {
    if (whodunnit) {
      text = 'updated the deal stage from';
    } else {
      text = 'Deal stage updated from';
    }
  } else {
    if (whodunnit) {
      text = 'created the deal under';
    } else {
      text = 'Deal was created under';
    }
  }

  return (
    <div className="deal-history-row py-4">
      {whodunnit && (
        <React.Fragment>
          <UserIcon admin={whodunnit.admin} size={32} user={whodunnit} />
          <b className="mx-2">{whodunnit.admin ? 'Buildout' : whodunnit.name}</b>
        </React.Fragment>
      )}
      {text}
      {previousStage && (
        <React.Fragment>
          <div className={`stage ${previousStage} ml-2`}>{stagesConfig[previousStage].label}</div>
          <FontAwesomeIcon className="ml-2" icon={faArrowRight} />
        </React.Fragment>
      )}
      <div className={`stage ${stage} ml-2`}>{stagesConfig[stage].label}</div>

      <div className="deal-history-timestamp">
        {formatDateTime(startTime)}
      </div>
    </div>
  );
}

Row.propTypes = {
  event: PropTypes.shape({
    previousStage: PropTypes.string,
    stage: PropTypes.string,
    startTime: PropTypes.string,
    whodunnit: PropTypes.object,
  }),
  stagesConfig: PropTypes.objectOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
  })),
};

export default Row;
